import {BottomSheet, Button} from '@ds/components';

type WarehouseReportModalProps = {
  show: boolean;
  loading: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const WarehouseReportModal: React.FC<WarehouseReportModalProps> = ({
  show,
  loading,
  onClose,
  onConfirm
}) => {
  return (
    <BottomSheet show={show} onClose={onClose} contentStyle={{padding: 16}}>
      <div className="flex flex-col gap-4">
        <p className="text-body-lg-emphasis text-gray-09">
          آیا می‌خواهید وارد صفحه اطلاعیه‌ها و هشدارها شوید؟
        </p>
        <div className="flex gap-2">
          <Button fullWidth variant="fill" color="secondary" disabled={loading} onClick={onClose}>
            خیر
          </Button>
          <Button fullWidth loading={loading} onClick={onConfirm}>
            بله
          </Button>
        </div>
      </div>
    </BottomSheet>
  );
};

export default WarehouseReportModal;
